import { setting, examList, examCategoryList, articleList } from "./api";

const getSetting = async context => {
  await setting()
    .then(response => {
      context.commit("SET_SETTING", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getExamList = async context => {
  await examList()
    .then(response => {
      context.commit("SET_EXAM_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getExamCategoryList = async context => {
  await examCategoryList()
    .then(response => {
      context.commit("SET_EXAM_CATEGORY_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getArticleList = async context => {
  await articleList()
    .then(response => {
      context.commit("SET_ARTICLE_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

export default {
  getSetting,
  getExamList,
  getExamCategoryList,
  getArticleList
};
